import { Role } from "@app/enums";

export const roleOptions = [
  { label: "Admin", value: Role.admin },
  { label: "User", value: Role.user },
  { label: "Creator", value: Role.creator },
];
